var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserlogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 8.66675C18.6665 12.3486 15.6816 15.3333 11.9998 15.3333C8.31787 15.3333 5.33301 12.3486 5.33301 8.66675C5.33301 4.98486 8.31787 2 11.9998 2C15.6816 2 18.6665 4.98486 18.6665 8.66675Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 18H6.33325C2.84131 18 0 20.8413 0 24.3333V29C0 29.552 0.447998 30 1 30H23C23.552 30 24 29.552 24 29V24.3333C24 20.8413 21.1587 18 17.6667 18Z",
    fill: "#6E7191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6816 13.2666L27.0149 8.93335C26.8269 8.75854 26.5815 8.66797 26.335 8.66797C25.6736 8.66797 25.3335 9.23071 25.3335 9.66675V12.6667H20.0002C19.2629 12.6667 18.667 13.2639 18.667 14C18.667 14.7361 19.2629 15.3333 20.0002 15.3333H25.3335V18.3333C25.3335 18.8879 25.7842 19.3333 26.3335 19.3333C26.5815 19.3333 26.8257 19.2415 27.0149 19.0667L31.6816 14.7334C31.8843 14.5439 32.0002 14.2773 32.0002 14C32.0002 13.7227 31.8843 13.4561 31.6816 13.2666Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserlogout);
export default __webpack_public_path__ + "static/media/userlogout.75f5230becf328e6830e22ac195472d0.svg";
export { ForwardRef as ReactComponent };